import styled from 'styled-components';
import { Box, Text } from '@rsos/base-components';
import { EVENT_PANE_MARGIN } from '../../../EventPane.styles';

export const KeywordsContainer = styled(Box).attrs({
  display: 'flex',
  width: '100%',
  position: 'relative',
})``;

export const KeywordsBox = styled(Box).attrs({
  backgroundColor: 'background',
  border: '1px solid',
  borderColor: 'heavyLineOutline',
  borderRadius: '5px',
  padding: '16px',
  overflow: 'hidden',
  width: '100%',
})``;

export const KeywordsHeader = styled(Box).attrs({
  horizontal: true,
  align: 'center',
  justify: 'space-between',
  marginBottom: `${EVENT_PANE_MARGIN}px`,
})`
  position: relative;
`;

export const KeywordsContent = styled(Box).attrs({
  horizontal: true,
  flexWrap: 'wrap',
  gridGap: '8px',
})``;

export const Keyword = styled(Box).attrs({
  backgroundColor: 'lightLineDivider',
  padding: '4px',
  borderRadius: '5px',
})``;

export const KeywordText = styled(Text).attrs({
  size: 'normal',
  color: 'primaryText',
})``;

export const PoweredByHarmonyWrapper = styled(Box).attrs({
  padding: '0px',
  width: '100%',
})`
  padding-right: calc(32px + 8px);
`;

export const CopyKeywordsWrapper = styled(Box).attrs({
  position: 'absolute',
})`
  right: 0;
  transform: translateX(0);
  opacity: 1;
`;
